export default __webpack_public_path__ + "static/newstwo-1a6c71751f4d227350d36b322a53a66f.png";